import { jwtDecode } from 'jwt-decode';

/**
 * Декодирование payload JWT без проверки подписи — только чтение claim'ов (подпись проверяет
 * бэкенд). Обёртка над `jwt-decode`: возвращает claim'ы либо null (пустой/некорректный токен),
 * чтобы вызывающим не ловить исключение.
 */
export function decodeJwt<T = Record<string, unknown>>(
  token: string | null | undefined
): T | null {
  if (!token) return null;
  try {
    return jwtDecode<T>(token);
  } catch {
    return null;
  }
}
